
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
export class DataAcquisitionManagementApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'data-acquisition-management'
    }

}
 